import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemDoName, FormItemDoNo} from '../DO/FormChooseDo.jsx'
import Model from './ModelDe.mjs'

export const FormItemDeTitle = props => (
    <FormItemBizProp
        Model={Model}
        prop="deTitle"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseDe(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemDoNo />
            <FormItemDoName />
            <FormItemDeTitle />
        </FormChooseDesign>
    )
}
